import MobileChevronLeftIcon from '@/assets/icons/mobile-chevron-left.svg?react'

import { BackButton, HeaderContent, HeaderWrapper, Title } from './styles'

interface HeaderProps {
  /** 가운데 노출 타이틀 */
  title: string
  /** 좌측 chevron-left 버튼 핸들러. 미지정 시 뒤로 버튼 자체 미노출 */
  onBack?: () => void
}

/**
 * payment webview 공통 헤더 (56px).
 *
 * Figma: 18850:202116 (밀봉비닐 나눔 헤더). Pretendard SemiBold 18 / line-height 26 / letter-spacing -0.18.
 * 상단 status bar / safe-area 는 Flutter 가 webview 컨테이너에 native inset 으로 확보하므로
 * 이 컴포넌트는 추가 상단 여백 없이 56px content 만 그린다.
 */
export function Header({ title, onBack }: HeaderProps) {
  return (
    <HeaderWrapper>
      <HeaderContent>
        {onBack && (
          <BackButton
            type='button'
            aria-label='뒤로 가기'
            onClick={onBack}
          >
            <MobileChevronLeftIcon
              width={24}
              height={24}
            />
          </BackButton>
        )}
        <Title>{title}</Title>
      </HeaderContent>
    </HeaderWrapper>
  )
}
